import { useLocation } from "react-router-dom";

export function usePageUserType() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/accelstars")) return "accelstars";
  else if (pathname.startsWith("/facility")) return "facility";
  else if (pathname.startsWith("/org")) return "org";
  else return "examinee";
}
